import App from "../../core/src/App";
import { Commands } from "../../core/src/commands/CommandEnum";
import CommandManager from "../../core/src/commands/CommandManager";
import GameEvents from "../../core/src/const/GameEvents";
import SpinModel from "../../core/src/model/SpinModel";
import SpinEndState from "../../core/src/states/SpinEndState";

export default class VendorSpinEndState extends SpinEndState {
    protected onResponse() {
        App.dispatcher.emit(GameEvents.SPIN_COMPLETE);
        if (SpinModel.isInFreespins()) {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            )
        }
        this.exit();
    }
};
